{
  "host": "Host",
  "user": "User",
  "password": "Password",
  "open": "Open console",
  "close": "Close console",
  "modal": {
    "title": "Open console"
  }
}